/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export type Zahlungsmethodenstatus =
    | "ZAHLDATENAUSSTEHEND"
    | "BESTAETIGUNGAUSSTEHEND"
    | "AKTIONAUSSTEHEND"
    | "VERARBEITUNG"
    | "STORNIERT"
    | "ERFOLGREICHEINGERICHTET";

export class ZahlungsmethodenstatusSammlung {
    public static readonly zahldatenAusstehend: Zahlungsmethodenstatus = "ZAHLDATENAUSSTEHEND";
    public static readonly bestaetigungAusstehend: Zahlungsmethodenstatus = "BESTAETIGUNGAUSSTEHEND";
    public static readonly aktionAusstehend: Zahlungsmethodenstatus = "AKTIONAUSSTEHEND";
    public static readonly verarbeitung: Zahlungsmethodenstatus = "VERARBEITUNG";
    public static readonly storniert: Zahlungsmethodenstatus = "STORNIERT";
    public static readonly erfolgreichEingerichtet: Zahlungsmethodenstatus = "ERFOLGREICHEINGERICHTET";
}

export type Zahlungsmethodentyp =
    | "KARTE"
    | "SEPA";

export class ZahlungsmethodentypSammlung {
    public static readonly karte: Zahlungsmethodentyp = "KARTE";
    public static readonly sepa: Zahlungsmethodentyp = "SEPA";
}

export type Marke =
    | "UNBEKANNT"
    | "AMERICANEXPRESS"
    | "DINERSCLUB"
    | "DISCOVER"
    | "JCB"
    | "MASTERCARD"
    | "UNIONPAY"
    | "VISA";

export class MarkeSammlung {
    public static readonly unbekannt: Marke = "UNBEKANNT";
    public static readonly americanExpress: Marke = "AMERICANEXPRESS";
    public static readonly dinersClub: Marke = "DINERSCLUB";
    public static readonly discover: Marke = "DISCOVER";
    public static readonly jcb: Marke = "JCB";
    public static readonly mastercard: Marke = "MASTERCARD";
    public static readonly unionpay: Marke = "UNIONPAY";
    public static readonly visa: Marke = "VISA";
}

export interface KarteDaten {
    marke: Marke;
    nummerEndetMit: string;
    gueltigBisJahr: number;
    gueltigBisMonat: number;
}

export interface SepaDaten {
    ibanEndetMit: string;
    name: string;
    eMail: string;
    land: string;
    bankleitzahl: string;
}

export interface Zahlungsmethode {
    zahlungsmethodeId: string;
    zahlungsmethodeTyp: Zahlungsmethodentyp;
    status: Zahlungsmethodenstatus;
    karte?: KarteDaten;
    sepa?: SepaDaten;
}